/**
 * Generates responsive Tailwind transform classes for scale and translate.
 * Uses arbitrary value syntax for precise control (e.g., scale-[1.5], translate-x-[10%]).
 *
 * @param options - Configuration options for generating the classes
 * @param options.values - Responsive transform values for mobile, tablet, and desktop
 * @returns Object containing the generated Tailwind class string and inline style for transform
 */
export function generateResponsiveTransformClasses(options) {
    const { values } = options;
    const { mobile, tablet, desktop } = values;
    const classes = [];
    // Always add the transform class to enable transforms
    classes.push("transform");
    // Mobile values (no prefix, these are the base)
    if (mobile) {
        if (mobile.scale !== undefined) {
            const scaleValue = mobile.scale / 100;
            classes.push(`scale-[${scaleValue}]`);
        }
        if (mobile.positionX !== undefined) {
            classes.push(`translate-x-[${mobile.positionX}%]`);
        }
        if (mobile.positionY !== undefined) {
            classes.push(`translate-y-[${mobile.positionY}%]`);
        }
    }
    // Tablet values (md: prefix)
    if (tablet) {
        if (tablet.scale !== undefined) {
            const scaleValue = tablet.scale / 100;
            classes.push(`md:scale-[${scaleValue}]`);
        }
        if (tablet.positionX !== undefined) {
            classes.push(`md:translate-x-[${tablet.positionX}%]`);
        }
        if (tablet.positionY !== undefined) {
            classes.push(`md:translate-y-[${tablet.positionY}%]`);
        }
    }
    // Desktop values (lg: prefix)
    if (desktop) {
        if (desktop.scale !== undefined) {
            const scaleValue = desktop.scale / 100;
            classes.push(`lg:scale-[${scaleValue}]`);
        }
        if (desktop.positionX !== undefined) {
            classes.push(`lg:translate-x-[${desktop.positionX}%]`);
        }
        if (desktop.positionY !== undefined) {
            classes.push(`lg:translate-y-[${desktop.positionY}%]`);
        }
    }
    return classes.join(" ");
}
